<template>
    <div :style="`text-align: right;height:${height+50}px`">
        <el-button size="small" type="primary" @click="calculate">쌍둥이문제</el-button>
        <div id="question" class="question" :style="`width:${width}px;height:${height}px;margin-top:10px;background-color:#f4f4f4`">
            <div id="app" style="position: absolute; text-align: left;">
                <VueDragResize v-for="(rect, index) in my_rects.filter(rec => rec.type !== 'var')"
                               :key="index"
                               :w="rect.width"
                               :h="rect.height"
                               :x="rect.left"
                               :y="rect.top"
                               :parentW="listWidth"
                               :parentH="listHeight"
                               :axis="rect.axis"
                               :preventActiveBehavior="true"
                               :isActive="false"
                               :minw="rect.minw"
                               :minh="rect.minh"
                               :isDraggable="false"
                               :isResizable="false"
                               :parentLimitation="rect.parentLim"
                               :snapToGrid="rect.snapToGrid"
                               :aspectRatio="rect.aspectRatio"
                               :z="rect.zIndex"
                               v-on:dragging="changePosition($event, rect)"
                               v-on:resizing="changeSize($event, rect)">
                    <div class="filler" v-if="rect.type === 'text' || rect.type === 'num'" :style="'color:'+rect.foreColor+'backgroundColor:'+rect.color+';text-align: '+rect.alignment+';font-size:'+rect.size+'px;font-weight:'+rect.border+';border:'+rect.border_weight+'px solid ' + rect.border_color">
                        <span>{{rect.text}}</span>
                    </div>
                    <hr v-else-if="rect.type === 'line' && rect.direct === 'horizontal'" :style="'position:absolute; display: inline-block;width:'+rect.size+`px;border-top: ${rect.thickness}px ${rect.style} ${rect.color};`">
                    <div v-else-if="rect.type === 'line' && rect.direct === 'vertical'" :style="'position:absolute; display: inline-block;height:'+rect.size+`px;border-left: ${rect.thickness}px ${rect.style} ${rect.color};`"></div>
                </VueDragResize>
            </div>
        </div>
    </div>
</template>

<script>
    import VueDragResize from 'vue-drag-resize'
    import { mapGetters } from 'vuex';
    import Variables from '../../controller/variables'

    export default {
        name: "TesterViewer",
        components: {
            VueDragResize
        },
        props: ['width', 'height', 'rects'],
        data() {
            return {
                my_rects: []
            }
        },
        created() {
            this.calculate()
        },
        mounted() {
        },
        methods: {
            calculate: function () {
                let v = new Variables()
                this.my_rects = JSON.parse(JSON.stringify(this.rects))
                for (let rect of this.my_rects) {
                    switch (rect.type) {
                        case 'num':
                            rect.text = '1.'
                            break;
                        case 'var':
                            v.setFunction(rect.label, rect.function, rect.text)
                            break;
                        case 'text':
                            if (rect.text.length > 0 && rect.text[0] === '[')
                                rect.text = v.getLabel(rect.text)
                            break;
                    }
                }
            }
        },
        watch: {
        },
        computed: mapGetters({
        })
    }
</script>

<style>
    .title div.chapter2 small {
        font-size: 12px;
        font-family: inherit;
    }
    .logo > img {
        position: relative;
        top: 23px;
        margin: auto auto;
    }
</style>